import React from "react";
import {
  Typography,
  Container,
  Box,
  Link,
  SvgIcon
} from "@mui/material";
import { motion } from "framer-motion";
import { fadeInUp } from "../../utils/animations";
import Privacy from "../../assets/pdf/Get-Sorted-Privacy-Statement.pdf";
import Paia from "../../assets/pdf/PAIA-Manual.pdf";
import Errands from "../../assets/pdf/Errand-Services-Vehicle-Standards-Annexure-final-.pdf";
import ServiceProvider from "../../assets/pdf/Service-Provider-Agreement.pdf";
import Listing from "../../assets/pdf/Service-Provider-Profile-listing-Agreement.pdf";
import UsersTerms from "../../assets/pdf/User-Terms-Conditions.pdf";

/**
 * Minimal placeholder Visa icon. Replace with official brand SVG if desired.
 */
function VisaIcon(props) {
  return (
    <SvgIcon viewBox="0 0 100 30" {...props}>
      <path
        fill="#1A1F71"
        d="M45.2 11.5h-4.1l-2.6 7.4-1.2-7.4H33.5l2.1 11.3h3.4l4.2-11.3zM55.9 12.8c-.7-.3-1.7-.6-3-.8-1.3-.2-2.2-.3-2.9-.6-.6-.2-.9-.5-.9-.8 0-.5.5-.9 1.4-.9.9 0 1.8.3 2.7.9l1.2-2.2c-1.1-.6-2.3-.9-3.6-.9-3 0-4.5 1.7-4.5 3.3 0 .7.2 1.3.7 1.8.6.6 1.3.9 2.3 1.2.8.2 1.5.4 2 .5.5.2.8.3.9.4.2.1.2.3.2.4 0 .6-.8.9-1.5.9-1 0-1.9-.3-2.8-1l-1.3 2c1.2.9 2.6 1.3 4.2 1.3 3 0 4.6-1.7 4.6-3.4 0-.6-.1-1.2-.5-1.7-.4-.4-1.2-.9-2.2-1.3z"
      />
      <path
        fill="#142688"
        d="M72.7 11.5h-3.2c-.4 0-.7.3-.9.6l-4.6 10.5h3.2l.6-1.7h3.7l.3 1.7h2.8l-2.1-11.1zM67.3 17l1.5-4.1 1.7 4.1h-3.2z"
      />
      <path
        fill="#F7B600"
        d="M88.1 11.5h-2.7c-.4 0-.7.2-.9.6l-4.5 10.5h3l.6-1.6h3.2l.3 1.6h2.7l-2-11.1zm-3.4 6.7l1.2-3.4 1.4 3.4h-2.6z"
      />
    </SvgIcon>
  );
}

/**
 * Minimal placeholder Mastercard icon. Replace with official brand SVG if desired.
 */
function MastercardIcon(props) {
  return (
    <SvgIcon viewBox="0 0 50 30" {...props}>
      {/* Two overlapping circles to approximate Mastercard logo */}
      <circle cx="19" cy="15" r="13" fill="#EB001B" />
      <circle cx="31" cy="15" r="13" fill="#F79E1B" />
      <path
        fill="#FF5F00"
        d="M19 2C26.1797 2 32 7.8203 32 15c0 7.1797-5.8203 13-13 13"
      />
    </SvgIcon>
  );
}

const FrontendFooter = () => {
  return (
    <motion.div
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <Box
        sx={{
          backgroundColor: "grey.900",
          color: "grey.300",
          py: 4,
          textAlign: "center",
        }}
      >
        <Container>
          {/* Links Section */}
          <Box
            sx={{
              mb: 2,
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Link href={`${Privacy}`} color="inherit" underline="hover">
              Privacy Policy
            </Link>
            <Link href={`${Privacy}`} color="inherit" underline="hover">
              Privacy Statement
            </Link>
            <Link href={`${Paia}`} color="inherit" underline="hover">
              PAIA Manual
            </Link>
            <Link href={`${UsersTerms}`} color="inherit" underline="hover">
              User Terms and Conditions
            </Link>
            <Link href={`${Listing}`} color="inherit" underline="hover">
              Service Provider Profile Listing Agreement
            </Link>
            <Link href={`${ServiceProvider}`} color="inherit" underline="hover">
              Service Provider Terms and Conditions
            </Link>
            <Link href={`${Errands}`} color="inherit" underline="hover">
              Errand Services and vehicle standards
            </Link>
            <Link href="mailto:support@getsortedservices.com" color="inherit" underline="hover">
              Email Us
            </Link>
            <Link href="tel:0837042161" color="inherit" underline="hover">
              Call Us
            </Link>
          </Box>

          {/* Copyright */}
          <Typography variant="body2">
            © 2025 Get Sorted Services. All rights reserved.
          </Typography>

          {/* Payment Icons */}
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "center",
              gap: 3,
            }}
          >
            <MastercardIcon sx={{ fontSize: 40 }} />
            <VisaIcon sx={{ fontSize: 40 }} />
          </Box>
        </Container>
      </Box>
    </motion.div>
  );
};

export default FrontendFooter;
